var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7300_244306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4754 16.6865C16.3887 15.7554 15.7972 15.1471 15.2264 14.5591C14.7298 14.0472 14.2608 13.5637 14.0524 12.8533C13.48 10.887 13.1887 9.71404 11.5497 9.30537C9.91057 8.89671 9.10094 9.79558 7.67016 11.2617C7.15199 11.7923 6.50802 11.9991 5.82833 12.2185C5.04821 12.47 4.24201 12.7288 3.72775 13.5082C3.53369 13.7871 3.39312 14.0996 3.31317 14.4298C2.96667 15.8195 3.79166 17.2263 5.01799 17.5321C6.24431 17.8378 8.01405 17.6222 9.39388 17.9662C10.7737 18.3103 12.2125 19.3259 13.4542 19.6355C14.6959 19.9451 16.0657 19.0855 16.4122 17.6958C16.4954 17.3661 16.5168 17.0239 16.4754 16.6865Z",
    fill: "#D4BC87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.45312 11.0134C5.50813 11.2765 6.63755 10.3901 6.97575 9.03363C7.31395 7.67718 6.73286 6.36433 5.67785 6.10128C4.62283 5.83824 3.49341 6.72462 3.15521 8.08106C2.81701 9.43751 3.39811 10.7504 4.45312 11.0134Z",
    fill: "#D4BC87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09179 8.69309C10.1468 8.95614 11.2762 8.06976 11.6144 6.71332C11.9526 5.35687 11.3715 4.04402 10.3165 3.78097C9.26151 3.51793 8.13208 4.4043 7.79389 5.76075C7.45569 7.11719 8.03678 8.43005 9.09179 8.69309Z",
    fill: "#D4BC87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0039 9.91966C15.0589 10.1827 16.1883 9.29632 16.5265 7.93988C16.8647 6.58343 16.2836 5.27058 15.2286 5.00753C14.1736 4.74449 13.0442 5.63087 12.706 6.98731C12.3678 8.34376 12.9489 9.65661 14.0039 9.91966Z",
    fill: "#D4BC87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0078 14.1462C18.0628 14.4093 19.1922 13.5229 19.5304 12.1664C19.8686 10.81 19.2875 9.49714 18.2325 9.2341C17.1775 8.97105 16.0481 9.85743 15.7099 11.2139C15.3717 12.5703 15.9528 13.8832 17.0078 14.1462Z",
    fill: "#D4BC87"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7300_244306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(4.44727 0.578125) rotate(14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaw);
export default __webpack_public_path__ + "static/media/paw.31cb01a6cb9c2229fdf450e26e823073.svg";
export { ForwardRef as ReactComponent };